<form [formGroup]="incubatorForm" (ngSubmit)="submit()" class="flex justify-between flex-col h-full">
  <div class="text-ladder-black">
    <h1 class="font-bold text-3xl">Register Your Incubator</h1>
    <p class="text-base opacity-80 mt-2">
      Enter your Incubator's name and address details
    </p>
    <div class="grid grid-cols-12 gap-4 mt-5">
      <div class="col-span-12 form-group">
        <label for="incubator-name">Incubator Name</label>
        <input
          formControlName="incubatorName"
          id="incubator-name"
          placeholder="Enter your incubator's name"
          type="text"
          minlength="3"
          autocomplete="off"
        />
        <div *ngIf="incubatorForm.get('incubatorName')?.invalid && incubatorForm.get('incubatorName')?.touched" class="text-red-600 text-sm mt-1">
          <span>Incubator Name is required.</span>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6 form-group">
        <label for="country">Country</label>
        <input
          formControlName="incubatorCountry"
          id="country"
          placeholder="Enter the incubator's country"
          type="text"
          autocomplete="off"
        />
        <div *ngIf="incubatorForm.get('incubatorCountry')?.invalid && incubatorForm.get('incubatorCountry')?.touched" class="text-red-600 text-sm mt-1">
          <span>Country is required.</span>
        </div>
      </div>
      <div class="col-span-12 md:col-span-6 form-group">
        <label for="city">City</label>
        <input
          formControlName="incubatorCity"
          id="city"
          placeholder="Enter the incubator's city"
          type="text"
          autocomplete="off"
        />
        <div *ngIf="incubatorForm.get('incubatorCity')?.invalid && incubatorForm.get('incubatorCity')?.touched" class="text-red-600 text-sm mt-1">
          <span>City is required.</span>
        </div>
      </div>
    </div>
    <p *ngIf="errorMessage" class="text-red-600 mt-4">{{ errorMessage }}</p>
  </div>

  <div class="w-full mt-4">
    <app-button type="submit" class="font-bold" [disabled]="incubatorForm.invalid || loading">
      <span *ngIf="!loading">Continue</span>
      <span *ngIf="loading">Registering...</span>
    </app-button>
    <div class="text-center mt-4">
      <span class="opacity-65 font-semibold mr-3">Already have an account?</span>
      <a [routerLink]="['/auth/login']" class="text-ladder-purpleMedium underline font-bold">Log in</a>
    </div>
  </div>
</form>
